// import { useEffect, useState } from 'react';
// import axios from 'axios';  // Ensure axios is installed
// import { Box } from '@mui/material';

// const GoogleCalendar = () => {
//     const [events, setEvents] = useState([]);
//     const apiKey = 'YOUR_API_KEY';  // Replace with your API Key
//     const calendarId = 'd2ce48ccb01872493e818e735efe6446b9fb2d19d85768f1bb64cea457204892@group.calendar.google.com';  // Replace with your calendar ID

//     const getEvents = async () => {
//         const url = `https://www.googleapis.com/calendar/v3/calendars/${encodeURIComponent(calendarId)}/events?key=${apiKey}`;

//         try {
//             const response = await axios.get(url);
//             setEvents(response.data.items);  // Update your state with the fetched events
//         } catch (error) {
//             console.error('Error fetching events:', error);
//         }
//     };

//     useEffect(() => {
//         getEvents();
//     }, []);

//     return (
//         <Box>
//             {events.map(event => (
//                 <div key={event.id}>{event.summary} at {event.start.dateTime}</div>
//             ))}
//         </Box>
//     );
// };

// export default GoogleCalendar;

import { Box } from "@mui/material";

const GoogleCalendar = () => {
    const calendarUrl = "https://calendar.google.com/calendar/embed?src=d2ce48ccb01872493e818e735efe6446b9fb2d19d85768f1bb64cea457204892%40group.calendar.google.com&ctz=America%2FNew_York";

    return (
        <Box
            sx={{
                position: 'relative',
                overflow: 'hidden',
                width: '100%', // Full width
                paddingTop: '56.25%', // Aspect ratio 16:9, adjust as needed
                marginTop: '20px',
                '@media (max-width: 600px)': {
                    height: '60vh', // Set height to 40vh on mobile devices
                    paddingTop: 0, // Remove paddingTop to avoid conflict with height
                },
            }}
        >
            <iframe
                src={calendarUrl}
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    border: 0,
                }}
                frameBorder="0"
                scrolling="no"
            ></iframe>
        </Box>
    );
};

export default GoogleCalendar;